import { adoptAssetManifest, loadAssetManifest } from '@sorrem/engine';
import type { AssetManifest } from '@sorrem/shared';

/** Where the page remembers the last asset manifest it loaded. */
const STORAGE_KEY = 'sorrem:asset-manifest';

/**
 * Starts the page's asset manifest (#285): adopts the copy remembered from
 * the last visit at once, so the first screen renders versioned URLs (and
 * its precached images come straight from the cache), then loads the
 * server's and remembers it. A file changed since the remembered copy is
 * shown from its old URL only until the server's arrives a moment later.
 * Call once, before the first render.
 */
export function seedAssetManifest(): void {
    try {
        const remembered = localStorage.getItem(STORAGE_KEY);
        if (remembered !== null) {
            adoptAssetManifest(JSON.parse(remembered) as AssetManifest);
        }
    } catch {
        // No storage, or a copy that doesn't parse: the server's is a moment away.
    }
    void loadAssetManifest().then((loaded) => {
        if (loaded === null) {
            return;
        }
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(loaded));
        } catch {
            // Storage full or blocked: the next visit loads the server's first.
        }
    });
}
